export const environment = {
  production: true,
  stage: 'dev',
  appVersion: require('../../package.json').version + '-devessp', // eslint-disable-line
  appName: require('../../package.json').name, // eslint-disable-line
  appPrefix: 'quotingtoolpro',

  portalMetaBackendUrl: 'https://essp-api-beportalmetadata-dev.acp-gruppe.com',
  appBackendUrl: 'https://essp-api-bequotingtoolpro-dev.acp-gruppe.com',
  portalHomeUrl: 'https://essp-dev.acp-gruppe.com',
  genericBackendUrl: 'https://essp-api-besalesnavigator-dev.acp-gruppe.com',

  issuer: 'https://ciam-dev.acp-gruppe.com',
  tokenEndpoint: 'https://ciam-dev.acp-gruppe.com/token-srv/token',
  clientId: '8a6807ac-2fe2-4b9e-af5d-89daf57fb0d4',
  scope: 'openid profile roles groups acpprofile offline_access',
};
